import { useTranslation } from 'react-i18next';
import type { HolidayStatus } from '../../api/account/accountApiTypes';

/**
 * The credit the holiday data's licence (ODbL) asks for, wherever the data is
 * shown (serial-use plan §0.3 D1). Comes from the server with the status, so
 * the source and licence are named in one place.
 */
const HolidaySourceCredit = ({ credit }: Readonly<{ credit: HolidayStatus['credit'] }>) => {
    const { t } = useTranslation();
    return (
        <p className={'text-xs text-foreground/60'}>
            {t('services.holiday_region.credit_prefix')}{' '}
            <a href={credit.url} target={'_blank'} rel={'noreferrer'} className={'underline'}>{credit.name}</a>
            {', '}
            <a href={credit.licenceUrl} target={'_blank'} rel={'noreferrer'} className={'underline'}>{credit.licence}</a>
        </p>
    );
};

export default HolidaySourceCredit;
